import React from 'react';
import { motion } from 'framer-motion';
import { Star, TrendingDown, BatteryCharging } from 'lucide-react';
const testimonials = [{
  quote: 'El médico me tenía amenazado con la Metformina. Compré el Código, empecé a comer mis tacos en el orden que dice LLOYD y en 3 semanas mi glucosa en ayunas bajó de 115 a 92. ¡Incluso mi doctor me preguntó qué estaba haciendo!',
  author: 'José R.',
  location: 'Texas',
  result: 'Glucosa normalizada en 21 días',
  icon: TrendingDown,
  initials: 'JR'
}, {
  quote: 'Lo mejor es que mi esposo también lo hace conmigo. No cocinamos cosas raras, solo seguimos las reglas del vinagre y de caminar 10 minutos. He bajado 12 libras sin dejar de comer rico.',
  author: 'María G.',
  location: 'Chicago',
  result: '-12 lbs y energía recuperada',
  icon: BatteryCharging,
  initials: 'MG'
}];
export function Testimonials() {
  return <section className="py-20 bg-cream-light" data-id="element-174">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <div className="text-center mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-bold text-forest-dark mb-4" data-id="element-177">
            Resultados Reales de Nuestra Comunidad
          </h2>
          <div className="flex justify-center space-x-1" data-id="element-178">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 text-gold fill-current" data-id="element-179" />)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-180">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-md border border-cream-dark relative" data-id="element-181">
              <div className="absolute -top-5 -left-2 text-6xl text-gold opacity-20 font-serif" data-id="element-182">
                "
              </div>

              <p className="text-lg text-gray-700 italic mb-8 relative z-10 min-h-[120px]" data-id="element-183">
                {testimonial.quote}
              </p>

              <div className="flex items-center justify-between border-t border-gray-100 pt-6" data-id="element-184">
                <div className="flex items-center" data-id="element-185">
                  <div className="w-12 h-12 bg-forest text-gold rounded-full flex items-center justify-center font-bold text-xl mr-4" data-id="element-186">
                    {testimonial.initials}
                  </div>
                  <div data-id="element-187">
                    <p className="font-bold text-forest-dark" data-id="element-188">
                      {testimonial.author}
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-189">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-4 bg-cream p-3 rounded-lg flex items-center text-forest-dark font-medium text-sm" data-id="element-190">
                <testimonial.icon className="w-5 h-5 text-gold mr-2" data-id="element-191" />
                Resultado: {testimonial.result}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}